import { ReactElement } from "react";
import styles from "./PipeSeparator.module.less";

export const PipeSeparator = (): ReactElement => {
	return (
		<span className={styles.root}>|</span>
	);
};
PipeSeparator.displayName="PipeSeparator";